export default "__VITE_ASSET__BvTeuqCX__"